'use es6';

import { AssetTypes } from 'ContentComponents/constants/AssetTypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { CardWrapper, CardSection } from 'foundations-components/transitional/components/Card';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Image } from 'foundations-components/transitional/components/Image';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { makeSpacedComponent } from 'ContentComponents/components/cmv2/components/SpacedComponent';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.themes.assetCard.${key}`;
const SpacedParagraph = makeSpacedComponent('p');
export const AssetCard = ({
  assetType,
  name,
  numberInstall,
  onClick,
  thumbnailUrl,
  selected
}) => {
  return /*#__PURE__*/_jsx(SelectableBox, {
    borderWidth: "0",
    onClick: onClick,
    selected: selected,
    "data-test-id": `asset-card__${assetType}:${name}`,
    children: /*#__PURE__*/_jsxs(CardWrapper, {
      compact: true,
      children: [/*#__PURE__*/_jsx(CardSection, {
        padding: "0",
        children: thumbnailUrl ? /*#__PURE__*/_jsx(View, {
          blockSize: "270px",
          maxBlockSize: "270px",
          overflow: "hidden",
          children: /*#__PURE__*/_jsx(Image, {
            src: thumbnailUrl
          })
        }) : /*#__PURE__*/_jsxs(Flex, {
          marginBlock: "500",
          flexDirection: "column",
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(Illustration, {
            name: "empty-state-charts",
            width: 200
          }), /*#__PURE__*/_jsx(SpacedParagraph, {
            marginBlockStart: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('noPreview')
            })
          })]
        })
      }), /*#__PURE__*/_jsxs(CardSection, {
        flush: true,
        padding: "300",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h5",
          paddingBlockEnd: "200",
          paddingBlockStart: "300",
          textAlign: "left",
          children: name
        }), assetType === AssetTypes.TEMPLATE && (numberInstall || numberInstall === 0) && /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('templateUsage'),
          options: {
            count: numberInstall
          }
        })]
      })]
    })
  });
};